import { useFeaturesQuery } from '~/queries/features'

export const useFeatureStore = defineStore('featureStore', () => {
  const { data, error, isLoading, refresh, refetch } = useFeaturesQuery()

  const features = computed(() => {
    const raw = data.value?.features

    if (!raw) {
      return null
    }

    return {
      ...raw,
      default_symbols_parsed: raw.default_symbols
        ? raw.default_symbols.split(',').map((symbol) => symbol.trim())
        : undefined,
      languages_parsed: raw.languages
        ? raw.languages
            .split(',')
            .map((language) => language.trim().toLowerCase())
            .filter(Boolean)
        : undefined
    }
  })

  const branding = computed(() => data.value?.branding ?? null)

  return {
    features,
    branding,
    error,
    isLoading,
    refresh,
    refetch
  }
})
